import icon from 'vue-svgicon';

icon.register({
    'regular/single-neutral-actions-question': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<circle pid="0" cx="6" cy="3.75" r="3" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path pid="1" d="M10.555 10.888A5.251 5.251 0 0 0 .75 13.5v2.25H3l.75 7.5h4.5l.323-3.233" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><circle pid="2" cx="17.25" cy="17.25" r="6" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path pid="3" d="M15.375 16.125A1.875 1.875 0 1 1 17.25 18M17.25 20.25a.375.375 0 1 0 .375.375.374.374 0 0 0-.375-.375h0" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
